export class BiometryValidationResponse {
    customerCode: string;
    valid: string;
    timestamp: string;
    user: string;
    errorMessage: string;
    biometryLogCode: string;
    origin:string;

    constructor() {
        this.customerCode = "";
        this.valid = "";
        this.timestamp = "";
        this.user = "";
        this.errorMessage = "";
        this.biometryLogCode = "";
        this.origin = "";
    }
}
